import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import DatePicker from 'material-ui/DatePicker';
import CircularProgress from 'material-ui/CircularProgress';
import LinearProgress from 'material-ui/LinearProgress';
import Snackbar from 'material-ui/Snackbar';
import Dialog from 'material-ui/Dialog';
import { List, ListItem } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import { API_BASE_URL } from '../endpoints';

const ENDPOINT = `${API_BASE_URL}/admin`;

const BRAND_BLUE   = '#284263';
const BRAND_ORANGE = '#fd9512';

const styles = {
    page:        { padding: '24px 32px 120px', maxWidth: 1180, margin: '0 auto', color: '#1f2937' },

    headerBar:   { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16, flexWrap: 'wrap', gap: 16 },
    pageTitle:   { fontSize: 22, fontWeight: 700, color: BRAND_BLUE, margin: 0 },
    pageSubtitle:{ fontSize: 12, color: '#6b7280', marginTop: 2 },

    toolbar:     { display: 'flex', alignItems: 'center', gap: 8, padding: '10px 14px', background: '#fff', borderRadius: 10, boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.04)' },
    datePickerStyle: { width: 140 },

    statsGrid:   { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 10, marginTop: 12 },
    stat:        { background: '#fff', borderRadius: 10, padding: '10px 14px', boxShadow: '0 1px 2px rgba(0,0,0,0.04)', borderLeft: `3px solid #d1d5db` },
    statOK:      { borderLeftColor: '#10b981' },
    statWarn:    { borderLeftColor: '#f59e0b' },
    statFail:    { borderLeftColor: '#ef4444' },
    statLabel:   { fontSize: 10, color: '#6b7280', textTransform: 'uppercase', letterSpacing: 0.6, fontWeight: 600 },
    statValue:   { fontSize: 17, fontWeight: 700, color: '#111827', marginTop: 2 },
    statDelta:   { fontSize: 11, color: '#6b7280', marginTop: 1 },

    groupCard:   { marginTop: 12, background: '#fff', borderRadius: 10, overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 1px 2px rgba(0,0,0,0.03)', borderLeft: `3px solid ${BRAND_BLUE}` },
    groupCardUnmapped: { borderLeftColor: BRAND_ORANGE, background: '#fffbf3' },
    groupHeader: { display: 'flex', alignItems: 'center', padding: '8px 14px', borderBottom: '1px solid #f3f4f6' },
    groupTitle:  { flex: 1, fontSize: 14, fontWeight: 600, color: '#111827', display: 'flex', alignItems: 'center', gap: 8 },
    groupBadge:  { fontSize: 10, padding: '2px 8px', borderRadius: 999, background: '#eef2ff', color: BRAND_BLUE, fontWeight: 600, letterSpacing: 0.3 },
    groupBadgeWarn: { background: '#fef3c7', color: '#92400e' },
    groupBadgeVAT: { background: '#dbeafe', color: '#1e40af' },
    groupSub:    { fontSize: 11, color: '#6b7280', fontWeight: 400 },
    groupTotal:  { fontSize: 15, fontWeight: 700, color: BRAND_BLUE },

    lineRow:     { display: 'grid', gridTemplateColumns: '28px 1fr 70px 90px 64px 28px', gap: 8, alignItems: 'center', padding: '3px 14px', borderBottom: '1px solid #f9fafb', fontSize: 12, minHeight: 30 },
    lineRowAlt:  { background: '#fafafa' },
    lineDesc:    { fontWeight: 500, color: '#111827', lineHeight: 1.2 },
    lineSub:     { fontSize: 10, color: '#9ca3af', marginTop: 0, lineHeight: 1.2 },
    lineNum:     { textAlign: 'right', color: '#374151', fontVariantNumeric: 'tabular-nums', fontSize: 12 },
    lineNumStrong: { textAlign: 'right', color: '#111827', fontWeight: 600, fontVariantNumeric: 'tabular-nums', fontSize: 12 },
    excludeBtn:  { minWidth: 24, height: 24, padding: 0, color: '#9ca3af' },

    taxPill:        { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '2px 8px', borderRadius: 999, background: '#eef2ff', color: BRAND_BLUE, fontSize: 11, fontWeight: 600, cursor: 'pointer', userSelect: 'none', border: '1px solid transparent', transition: 'all 0.15s' },
    taxPillZero:    { background: '#dbeafe', color: '#1e40af' },
    taxPillReduced: { background: '#fef3c7', color: '#92400e' },
    taxPillCustom:  { background: '#f3f4f6', color: '#374151' },

    submitBar:   { position: 'fixed', bottom: 0, left: 256, right: 0, padding: '10px 28px', background: 'rgba(255,255,255,0.96)', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 -2px 8px rgba(0,0,0,0.05)', zIndex: 5 },
    submitInfo:  { fontSize: 13, color: '#374151' },
    submitTotal: { fontSize: 16, fontWeight: 700, color: BRAND_BLUE, marginLeft: 12 },

    runResult:   { marginTop: 24, background: '#fff', borderRadius: 10, padding: '14px 18px', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' },
    runRow:      { display: 'flex', alignItems: 'center', gap: 12, padding: '8px 0', borderBottom: '1px solid #f3f4f6' },
    successPill: { display: 'inline-block', padding: '2px 8px', borderRadius: 999, background: '#d1fae5', color: '#065f46', fontSize: 10, fontWeight: 700, letterSpacing: 0.3 },
    failPill:    { display: 'inline-block', padding: '2px 8px', borderRadius: 999, background: '#fee2e2', color: '#991b1b', fontSize: 10, fontWeight: 700, letterSpacing: 0.3 },

    emptyState:  { padding: 40, textAlign: 'center', color: '#9ca3af', fontSize: 13, background: '#fff', borderRadius: 10, marginTop: 12 },
};

const authHeaders = () => ({
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('token')}`,
});

const fmtEur = (cents) => {
    const v = (cents || 0) / 100;
    return v.toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' });
};

const lastMonthRange = () => {
    const now = new Date();
    const from = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const to = new Date(now.getFullYear(), now.getMonth(), 0);
    return { from, to };
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// Silvasoft: 50/min en 2/sec. Met 1500ms ≈ 40/min — ruim onder beide grenzen.
const SILVASOFT_MIN_INTERVAL_MS = 1500;

const LAST_RUN_STORAGE_KEY = 'cloudhints_last_invoice_run_id';

const ymd = (d) => {
    if (!d) return '';
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
};

class Facturatie extends Component {
    state = (() => {
        const { from, to } = lastMonthRange();
        return {
            from, to,
            preview: null,
            loading: false,
            submitting: false,
            checked: {},     // user_id -> bool
            taxOverride: {}, // user_id -> int
            picker: null,    // { user_id } when koppel-dialog open
            relations: null, // [{relation_id, name, country_code, vat_number}]
            relationsLoading: false,
            relationsError: null,
            relationFilter: '',
            snackbar: { open: false, msg: '' },
            run: null,       // last submitted run
            confirm: null,   // { title, body, onConfirm, confirmLabel }
            taxPicker: null, // { user_id, anchor }
            progress: null,  // { done, total, current, results: [{name, ok, invoice_number, error}] }
            lastRunId: (() => { try { const v = localStorage.getItem(LAST_RUN_STORAGE_KEY); return v ? parseInt(v, 10) : null; } catch (e) { return null; } })(),
            loadingPrevRun: false,
            historyOpen: false,
            historyLoading: false,
            historyRuns: null,
        };
    })();

    componentDidMount() {
        this.loadPreview();
    }

    persistLastRunId = (id) => {
        try {
            if (id) localStorage.setItem(LAST_RUN_STORAGE_KEY, String(id));
        } catch (e) {}
        this.setState({ lastRunId: id || this.state.lastRunId });
    };

    openHistory = () => {
        this.setState({ historyOpen: true, historyLoading: true });
        fetch(`${ENDPOINT}/invoice_runs`, { headers: authHeaders() })
            .then((r) => r.json().then((j) => ({ ok: r.ok, body: j })))
            .then(({ ok, body }) => {
                if (!ok) throw new Error(body.error || 'Kan historie niet laden');
                this.setState({ historyLoading: false, historyRuns: body });
            })
            .catch((err) => this.setState({ historyLoading: false, snackbar: { open: true, msg: err.message } }));
    };

    closeHistory = () => this.setState({ historyOpen: false });

    selectFromHistory = (id) => () => {
        this.setState({ historyOpen: false });
        this.persistLastRunId(id);
        // mark id then trigger loadPrevious
        this.setState({ lastRunId: id }, this.loadPreviousRun);
    };

    loadPreviousRun = () => {
        const id = this.state.lastRunId;
        if (!id) return;
        this.setState({ loadingPrevRun: true });
        fetch(`${ENDPOINT}/invoice_runs/${id}`, { headers: authHeaders() })
            .then((r) => r.json().then((j) => ({ ok: r.ok, body: j })))
            .then(({ ok, body }) => {
                if (!ok) throw new Error(body.error || `Run ${id} niet gevonden`);
                this.setState({ loadingPrevRun: false, run: body });
                setTimeout(() => {
                    const el = document.getElementById('facturatie-result');
                    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 50);
            })
            .catch((err) => this.setState({ loadingPrevRun: false, snackbar: { open: true, msg: err.message } }));
    };

    loadPreview = () => {
        const { from, to } = this.state;
        this.setState({ loading: true, preview: null, run: null });
        fetch(`${ENDPOINT}/invoice_preview?from=${ymd(from)}&to=${ymd(to)}`, { headers: authHeaders() })
            .then((r) => r.json().then((j) => ({ ok: r.ok, body: j })))
            .then(({ ok, body }) => {
                if (!ok) throw new Error(body.error || 'Onbekende fout');
                const checked = {};
                const taxOverride = {};
                body.groups.forEach((g) => {
                    g.lines.forEach((l) => {
                        checked[l.user_id] = l.included && l.amount_excl_tax_cents > 0;
                        taxOverride[l.user_id] = l.tax_pc;
                    });
                });
                this.setState({ loading: false, preview: body, checked, taxOverride });
            })
            .catch((err) => this.setState({ loading: false, snackbar: { open: true, msg: `Laden mislukt: ${err.message}` } }));
    };

    toggleLine = (userId) => () => {
        this.setState((s) => ({ checked: { ...s.checked, [userId]: !s.checked[userId] } }));
    };

    toggleGroup = (group) => () => {
        const all = group.lines.every((l) => this.state.checked[l.user_id]);
        const upd = { ...this.state.checked };
        group.lines.forEach((l) => { if (!l.unmapped) upd[l.user_id] = !all; });
        this.setState({ checked: upd });
    };

    setTax = (userId) => (_e, value) => {
        const n = parseInt(value, 10);
        this.setState((s) => ({ taxOverride: { ...s.taxOverride, [userId]: isNaN(n) ? 0 : n } }));
    };

    openTaxPicker = (userId) => (e) => {
        e.preventDefault();
        this.setState({ taxPicker: { user_id: userId, anchor: e.currentTarget } });
    };

    pickTax = (userId, value) => () => {
        this.setState((s) => ({ taxOverride: { ...s.taxOverride, [userId]: value }, taxPicker: null }));
    };

    closeTaxPicker = () => this.setState({ taxPicker: null });

    openPicker = (userId) => () => {
        this.setState({ picker: { user_id: userId }, relationFilter: '' });
        if (!this.state.relations) this.loadRelations();
    };

    loadRelations = (force) => {
        this.setState({ relationsLoading: true, relationsError: null });
        const url = `${ENDPOINT}/silvasoft_relations${force ? '?refresh=1' : ''}`;
        fetch(url, { headers: authHeaders() })
            .then((r) => r.json().then((j) => ({ ok: r.ok, body: j })))
            .then(({ ok, body }) => {
                if (!ok) throw new Error(body.error || 'Kan Silvasoft-klanten niet ophalen');
                this.setState({ relationsLoading: false, relations: body });
            })
            .catch((err) => this.setState({ relationsLoading: false, relationsError: err.message }));
    };

    deriveTaxPc = (rel) => {
        const country = (rel.country_code || '').toUpperCase();
        if (!country || country === 'NL') return 21;
        if (rel.vat_number) return 0;
        return 21;
    };

    pickRelation = (rel) => () => {
        const userId = this.state.picker.user_id;
        const tax = this.deriveTaxPc(rel);
        const body = {
            silvasoft_relation_id: rel.relation_id,
            silvasoft_relation_name: rel.name,
            silvasoft_relation_country: rel.country_code || null,
            silvasoft_relation_vat: rel.vat_number || null,
            invoice_tax_pc: tax,
        };
        fetch(`${ENDPOINT}/customers/${userId}`, {
            method: 'PUT',
            headers: authHeaders(),
            body: JSON.stringify(body),
        })
            .then((r) => {
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                return r.json();
            })
            .then(() => {
                this.setState({ picker: null, snackbar: { open: true, msg: `Gekoppeld aan ${rel.name} (BTW ${tax}%)` } });
                this.loadPreview();
            })
            .catch((err) => this.setState({ snackbar: { open: true, msg: `Koppelen mislukt: ${err.message}` } }));
    };

    askConfirm = ({ title, body, confirmLabel, onConfirm }) => {
        this.setState({ confirm: { title, body, confirmLabel: confirmLabel || 'Doorgaan', onConfirm } });
    };

    closeConfirm = () => this.setState({ confirm: null });

    excludeUser = (userId, label, clicks, amount) => () => {
        this.askConfirm({
            title: 'Regel verwijderen',
            body: `Verwijder ${clicks} kliks van "${label}" (${amount}) uit deze periode? De kliks blijven in de database maar worden gemarkeerd als gefilterd — ze tellen niet meer mee in Stats per maand / klant / site.`,
            confirmLabel: 'Verwijderen',
            onConfirm: () => this.doExcludeUser(userId, label),
        });
    };

    doExcludeUser = (userId, label) => {
        const { from, to } = this.state;
        fetch(`${ENDPOINT}/invoice_preview/exclude_user`, {
            method: 'POST',
            headers: authHeaders(),
            body: JSON.stringify({ from: ymd(from), to: ymd(to), user_id: userId }),
        })
            .then((r) => r.json().then((j) => ({ ok: r.ok, body: j })))
            .then(({ ok, body }) => {
                if (!ok) throw new Error(body.error || 'Fout');
                this.setState({ snackbar: { open: true, msg: `${body.clicks_filtered} kliks gefilterd voor ${label}` } });
                this.loadPreview();
            })
            .catch((err) => this.setState({ snackbar: { open: true, msg: err.message } }));
    };

    submit = () => {
        const { preview, checked, taxOverride } = this.state;
        if (!preview) return;
        if (!preview.product_number_present) {
            this.setState({ snackbar: { open: true, msg: 'Eerst ProductNumber instellen via Silvasoft koppeling-pagina.' } });
            return;
        }
        const lines = [];
        preview.groups.forEach((g) => {
            g.lines.forEach((l) => {
                if (l.unmapped) return;
                lines.push({
                    user_id: l.user_id,
                    included: !!checked[l.user_id],
                    tax_pc: taxOverride[l.user_id] != null ? taxOverride[l.user_id] : l.tax_pc,
                    description: l.description,
                    amount_excl_tax_cents: l.amount_excl_tax_cents,
                    clicks_count: l.clicks_count,
                });
            });
        });
        const includedCount = lines.filter((l) => l.included).length;
        if (includedCount === 0) {
            this.setState({ snackbar: { open: true, msg: 'Geen regels aangevinkt.' } });
            return;
        }

        const totalCents = lines.filter((l) => l.included).reduce((s, l) => s + l.amount_excl_tax_cents, 0);
        const groupCount = new Set(preview.groups.filter((g) => !g.unmapped && g.lines.some((l) => this.state.checked[l.user_id])).map((g) => g.silvasoft_relation_id)).size;

        this.askConfirm({
            title: 'Verstuur naar Silvasoft',
            body: `Je staat op het punt ${groupCount} factu${groupCount === 1 ? 'ur' : 'ren'} (${includedCount} regel(s), totaal ${fmtEur(totalCents)} excl. BTW) te versturen naar Silvasoft. Doorgaan?`,
            confirmLabel: 'Verstuur',
            onConfirm: () => this.doSubmit(lines),
        });
    };

    doSubmit = async (lines) => {
        const { from, to, preview } = this.state;
        this.setState({ submitting: true, progress: { done: 0, total: 0, current: null, results: [] } });

        // Group selected lines per Silvasoft relation
        const byRelation = new Map();
        const usersById = new Map();
        preview.groups.forEach((g) => {
            if (g.unmapped) return;
            g.lines.forEach((l) => usersById.set(l.user_id, l));
        });
        lines.filter((l) => l.included).forEach((l) => {
            const u = usersById.get(l.user_id);
            if (!u || !u.silvasoft_relation_id) return;
            const rid = u.silvasoft_relation_id;
            const arr = byRelation.get(rid) || { rid, name: u.silvasoft_relation_name, lines: [] };
            arr.lines.push(l);
            byRelation.set(rid, arr);
        });

        const groups = Array.from(byRelation.values());
        const total = groups.length;
        this.setState({ progress: { done: 0, total, current: null, results: [] } });

        let runId = null;
        const results = [];

        try {
            // 1. Create run
            const runRes = await fetch(`${ENDPOINT}/invoice_runs`, {
                method: 'POST',
                headers: authHeaders(),
                body: JSON.stringify({ from: ymd(from), to: ymd(to) }),
            });
            const runBody = await runRes.json();
            if (!runRes.ok) throw new Error(runBody.error || 'Run aanmaken mislukt');
            runId = runBody.id;

            // 2. Send each group sequentially with throttling
            let lastCallAt = 0;
            for (let i = 0; i < groups.length; i++) {
                const g = groups[i];
                const elapsed = Date.now() - lastCallAt;
                if (lastCallAt > 0 && elapsed < SILVASOFT_MIN_INTERVAL_MS) {
                    await sleep(SILVASOFT_MIN_INTERVAL_MS - elapsed);
                }
                this.setState({ progress: { done: i, total, current: g.name, results: [...results] } });
                lastCallAt = Date.now();
                try {
                    const r = await fetch(`${ENDPOINT}/invoice_runs/${runId}/send_group`, {
                        method: 'POST',
                        headers: authHeaders(),
                        body: JSON.stringify({ silvasoft_relation_id: g.rid, lines: g.lines }),
                    });
                    const body = await r.json();
                    results.push({ name: g.name, rid: g.rid, ok: !!body.ok, invoice_number: body.invoice_number, invoice_reference: body.invoice_reference, error: body.error });
                } catch (e) {
                    results.push({ name: g.name, rid: g.rid, ok: false, error: e.message });
                }
                this.setState({ progress: { done: i + 1, total, current: null, results: [...results] } });
            }
        } catch (err) {
            this.setState({ snackbar: { open: true, msg: err.message } });
        }

        // 3. Always try to finalize and fetch full run, but FALLBACK to constructed run if it fails
        let finalRun = null;
        if (runId) {
            try {
                const finRes = await fetch(`${ENDPOINT}/invoice_runs/${runId}/finalize`, {
                    method: 'POST',
                    headers: authHeaders(),
                });
                if (finRes.ok) finalRun = await finRes.json();
            } catch (_e) { /* ignored — fall back below */ }
        }

        if (!finalRun) {
            // Build a synthetic run from results so the UI can still show + retry
            finalRun = {
                id: runId,
                period_label: preview.period_label,
                status: results.every((r) => r.ok) ? 'submitted' : results.some((r) => r.ok) ? 'partial' : 'failed',
                submitted_count: results.filter((r) => r.ok).length,
                failed_count: results.filter((r) => !r.ok).length,
                total_excl_tax_cents: 0,
                lines: results.flatMap((r) => {
                    const orig = lines.filter((l) => {
                        const u = usersById.get(l.user_id);
                        return u && u.silvasoft_relation_id === r.rid && l.included;
                    });
                    return orig.map((l, idx) => ({
                        id: `synth-${r.rid}-${idx}`,
                        user_id: l.user_id,
                        silvasoft_relation_id: r.rid,
                        silvasoft_relation_name: r.name,
                        silvasoft_invoice_number: r.invoice_number,
                        silvasoft_invoice_reference: r.invoice_reference || `CH-RUN${runId}-REL${r.rid}`,
                        clicks_count: l.clicks_count,
                        amount_excl_tax_cents: l.amount_excl_tax_cents,
                        tax_pc: l.tax_pc,
                        description: l.description,
                        status: r.ok ? 'submitted' : 'failed',
                        error_message: r.error,
                    }));
                }),
            };
        }

        const submitted = finalRun.submitted_count || 0;
        const failed = finalRun.failed_count || 0;
        this.setState({
            submitting: false,
            progress: null,
            run: finalRun,
            snackbar: { open: true, msg: `Klaar — ${submitted} verzonden${failed ? `, ${failed} mislukt` : ''}` },
        });
        if (finalRun && finalRun.id) this.persistLastRunId(finalRun.id);
    };

    renderReconciliation() {
        const { preview, checked } = this.state;
        if (!preview) return null;

        let includedCents = 0;
        preview.groups.forEach((g) => {
            g.lines.forEach((l) => { if (checked[l.user_id]) includedCents += l.amount_excl_tax_cents; });
        });

        const mr = preview.monthreport;
        let mrStyle = styles.statOK;
        let mrLabel = '—';
        let mrDelta = '';
        let aangevinktStyle = styles.statOK;

        if (mr) {
            mrLabel = fmtEur(mr.revenue_cloudhints_cents);
            const diff = includedCents - mr.revenue_cloudhints_cents;
            if (Math.abs(diff) > 1) {
                aangevinktStyle = Math.abs(diff) > 100 ? styles.statFail : styles.statWarn;
                mrDelta = `${diff > 0 ? '+' : ''}${fmtEur(diff)} verschil`;
            } else {
                mrDelta = '✓ klopt';
            }
        } else {
            aangevinktStyle = styles.statWarn;
            mrLabel = 'n.v.t.';
            mrDelta = 'geen volledige kalendermaand';
        }

        const productStyle = preview.product_number_present ? styles.statOK : styles.statFail;

        return (
            <div style={styles.statsGrid}>
                <div style={{ ...styles.stat }}>
                    <div style={styles.statLabel}>Periode</div>
                    <div style={styles.statValue}>{preview.period_label}</div>
                </div>
                <div style={{ ...styles.stat, ...aangevinktStyle }}>
                    <div style={styles.statLabel}>Aangevinkt totaal</div>
                    <div style={styles.statValue}>{fmtEur(includedCents)}</div>
                    <div style={styles.statDelta}>{mrDelta}</div>
                </div>
                <div style={{ ...styles.stat, ...mrStyle }}>
                    <div style={styles.statLabel}>Stats per maand</div>
                    <div style={styles.statValue}>{mrLabel}</div>
                    {mr && <div style={styles.statDelta}>{mr.source === 'live' ? 'live berekend' : 'gecached'}</div>}
                </div>
                <div style={{ ...styles.stat, ...productStyle }}>
                    <div style={styles.statLabel}>Silvasoft product</div>
                    <div style={styles.statValue}>{preview.product_number || 'NIET INGESTELD'}</div>
                </div>
            </div>
        );
    }

    renderGroup = (g, idx) => {
        const groupChecked = g.lines.every((l) => this.state.checked[l.user_id]);
        const reverseCharge = !g.unmapped && g.lines[0] && g.lines[0].tax_pc === 0 && (g.silvasoft_relation_country || '').toUpperCase() !== 'NL';

        return (
            <div key={idx} style={{ ...styles.groupCard, ...(g.unmapped ? styles.groupCardUnmapped : {}) }}>
                <div style={styles.groupHeader}>
                    {!g.unmapped && (
                        <Checkbox checked={groupChecked} onCheck={this.toggleGroup(g)} style={{ width: 32, marginRight: 4 }} iconStyle={{ fill: BRAND_BLUE }} />
                    )}
                    {g.unmapped && <span style={{ width: 32, textAlign: 'center', fontSize: 16 }}>⚠</span>}
                    <div style={styles.groupTitle}>
                        <span>{g.unmapped ? 'Niet gekoppeld aan Silvasoft' : g.silvasoft_relation_name}</span>
                        {!g.unmapped && (
                            <span style={{ ...styles.groupBadge }}>#{g.silvasoft_relation_id}</span>
                        )}
                        {!g.unmapped && g.silvasoft_relation_country && (
                            <span style={{ ...styles.groupBadge, ...styles.groupBadgeWarn }}>{g.silvasoft_relation_country}</span>
                        )}
                        {reverseCharge && (
                            <span style={{ ...styles.groupBadge, ...styles.groupBadgeVAT }}>BTW verlegd</span>
                        )}
                        <span style={styles.groupSub}>· {g.lines.length} regel{g.lines.length === 1 ? '' : 's'}</span>
                    </div>
                    <div style={styles.groupTotal}>{fmtEur(g.total_excl_tax_cents)}</div>
                </div>

                {g.lines.map((l, i) => (
                    <div key={l.user_id} style={{ ...styles.lineRow, ...(i % 2 === 1 ? styles.lineRowAlt : {}) }}>
                        {g.unmapped ? (
                            <span></span>
                        ) : (
                            <Checkbox checked={!!this.state.checked[l.user_id]} onCheck={this.toggleLine(l.user_id)} iconStyle={{ fill: BRAND_BLUE }} />
                        )}
                        <div>
                            <div style={styles.lineDesc}>{l.invoice_line_label}</div>
                            <div style={styles.lineSub}>{l.user_email} · #{l.user_id}</div>
                        </div>
                        <div style={styles.lineNum}>{l.clicks_count} kliks</div>
                        <div style={styles.lineNumStrong}>{fmtEur(l.amount_excl_tax_cents)}</div>
                        {g.unmapped ? (
                            <FlatButton label="Koppel" primary onClick={this.openPicker(l.user_id)} style={{ height: 24, lineHeight: '24px', minWidth: 60 }} labelStyle={{ fontSize: 11, padding: '0 8px' }} />
                        ) : (
                            (() => {
                                const tax = this.state.taxOverride[l.user_id] != null ? this.state.taxOverride[l.user_id] : l.tax_pc;
                                let pillStyle = styles.taxPill;
                                if (tax === 0) pillStyle = { ...styles.taxPill, ...styles.taxPillZero };
                                else if (tax === 9) pillStyle = { ...styles.taxPill, ...styles.taxPillReduced };
                                else if (tax !== 21) pillStyle = { ...styles.taxPill, ...styles.taxPillCustom };
                                return (
                                    <span style={pillStyle} onClick={this.openTaxPicker(l.user_id)}>
                                        {tax}% ▾
                                    </span>
                                );
                            })()
                        )}
                        <FlatButton
                            label="✕"
                            title="Verwijder regel + kliks uit alle stats"
                            onClick={this.excludeUser(l.user_id, l.invoice_line_label, l.clicks_count, fmtEur(l.amount_excl_tax_cents))}
                            style={styles.excludeBtn}
                            labelStyle={{ fontSize: 14, padding: 0, color: '#9ca3af' }}
                            hoverColor="rgba(239,68,68,0.08)"
                        />
                    </div>
                ))}
            </div>
        );
    };

    retryGroup = (ref) => async () => {
        const { run, retrying } = this.state;
        if (!run || retrying) return;
        this.setState({ retrying: { ref } });
        try {
            const r = await fetch(`${ENDPOINT}/invoice_runs/${run.id}/retry_group`, {
                method: 'POST',
                headers: authHeaders(),
                body: JSON.stringify({ silvasoft_invoice_reference: ref }),
            });
            const body = await r.json();
            if (!r.ok) throw new Error(body.error || 'Retry mislukt');
            const result = body.result || body;
            const newRun = body.run || run;
            this.setState({
                retrying: null,
                run: newRun,
                snackbar: { open: true, msg: result.ok ? `Factuur #${result.invoice_number} alsnog gelukt` : `Nog steeds mislukt: ${result.error}` },
            });
            if (newRun && newRun.id) this.persistLastRunId(newRun.id);
        } catch (err) {
            this.setState({ retrying: null, snackbar: { open: true, msg: err.message } });
        }
    };

    renderRunResult() {
        const { run, retrying } = this.state;
        if (!run) return null;
        const groups = {};
        (run.lines || []).forEach((l) => {
            const k = l.silvasoft_invoice_reference || `_${l.id}`;
            groups[k] = groups[k] || { ref: l.silvasoft_invoice_reference, name: l.silvasoft_relation_name, status: l.status, invoice_number: l.silvasoft_invoice_number, error: l.error_message, lines: [] };
            groups[k].lines.push(l);
        });
        return (
            <div id="facturatie-result" style={styles.runResult}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                    <h3 style={{ margin: 0, color: BRAND_BLUE, fontSize: 16 }}>Verzendresultaat — run #{run.id}</h3>
                    <span style={{ fontSize: 12, color: '#6b7280' }}>{run.period_label}</span>
                    <span style={{ flex: 1 }} />
                    <span style={styles.successPill}>{run.submitted_count} verzonden</span>
                    {run.failed_count > 0 && <span style={styles.failPill}>{run.failed_count} mislukt</span>}
                </div>
                {Object.values(groups).map((g, i) => {
                    const isRetrying = retrying && retrying.ref === g.ref;
                    return (
                        <div key={i} style={styles.runRow}>
                            <span style={g.status === 'submitted' ? styles.successPill : styles.failPill}>
                                {g.status === 'submitted' ? `#${g.invoice_number}` : 'MISLUKT'}
                            </span>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontWeight: 600 }}>{g.name}</div>
                                <div style={{ fontSize: 11, color: '#9ca3af' }}>{g.ref} · {g.lines.length} regel{g.lines.length === 1 ? '' : 's'}</div>
                                {g.error && <div style={{ color: '#b91c1c', fontSize: 12, marginTop: 4 }}>{g.error}</div>}
                            </div>
                            <div style={{ fontWeight: 600, color: BRAND_BLUE, fontVariantNumeric: 'tabular-nums', minWidth: 80, textAlign: 'right' }}>
                                {fmtEur(g.lines.reduce((s, l) => s + l.amount_excl_tax_cents, 0))}
                            </div>
                            {g.status === 'failed' && (
                                <FlatButton
                                    label={isRetrying ? 'Bezig...' : 'Opnieuw'}
                                    primary
                                    disabled={!!retrying}
                                    onClick={this.retryGroup(g.ref)}
                                    style={{ height: 28, lineHeight: '28px', minWidth: 80 }}
                                    labelStyle={{ fontSize: 12 }}
                                    icon={isRetrying ? <CircularProgress size={14} thickness={2} /> : null}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        );
    }

    renderHistoryDialog() {
        const { historyOpen, historyLoading, historyRuns } = this.state;
        if (!historyOpen) return null;

        const statusPill = (status) => {
            const map = {
                submitted: { bg: '#d1fae5', color: '#065f46', label: 'Verzonden' },
                partial:   { bg: '#fef3c7', color: '#92400e', label: 'Gedeeltelijk' },
                failed:    { bg: '#fee2e2', color: '#991b1b', label: 'Mislukt' },
                pending:   { bg: '#f3f4f6', color: '#374151', label: 'Bezig' },
            };
            const s = map[status] || map.pending;
            return (
                <span style={{ display: 'inline-block', padding: '2px 8px', borderRadius: 999, background: s.bg, color: s.color, fontSize: 10, fontWeight: 700, letterSpacing: 0.3 }}>
                    {s.label}
                </span>
            );
        };

        return (
            <Dialog
                title="Historie facturatie-runs"
                modal={false}
                open={true}
                onRequestClose={this.closeHistory}
                autoScrollBodyContent={true}
                contentStyle={{ width: 700, maxWidth: '95%' }}
                actions={[
                    <FlatButton label="Sluiten" onClick={this.closeHistory} />,
                ]}
            >
                {historyLoading && <div style={{ padding: 20, textAlign: 'center' }}><CircularProgress size={24} /></div>}
                {!historyLoading && historyRuns && historyRuns.length === 0 && (
                    <div style={{ padding: 20, color: '#6b7280', textAlign: 'center' }}>Nog geen runs.</div>
                )}
                {!historyLoading && historyRuns && historyRuns.length > 0 && (
                    <div>
                        {historyRuns.map((r) => (
                            <div
                                key={r.id}
                                onClick={this.selectFromHistory(r.id)}
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: '60px 1fr 110px 90px 90px',
                                    gap: 12,
                                    alignItems: 'center',
                                    padding: '10px 12px',
                                    borderBottom: '1px solid #f3f4f6',
                                    cursor: 'pointer',
                                    fontSize: 13,
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.background = '#f9fafb'}
                                onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                            >
                                <span style={{ color: '#6b7280', fontVariantNumeric: 'tabular-nums' }}>#{r.id}</span>
                                <div>
                                    <div style={{ fontWeight: 600 }}>{r.period_label}</div>
                                    <div style={{ fontSize: 11, color: '#9ca3af' }}>
                                        {r.created_at ? new Date(r.created_at).toLocaleString('nl-NL') : ''}
                                    </div>
                                </div>
                                {statusPill(r.status)}
                                <span style={{ fontSize: 12, color: '#374151', textAlign: 'right' }}>
                                    <span style={{ color: '#10b981' }}>{r.submitted_count || 0} ✓</span>
                                    {r.failed_count > 0 && <span style={{ color: '#ef4444', marginLeft: 6 }}>{r.failed_count} ✗</span>}
                                </span>
                                <span style={{ fontWeight: 600, color: BRAND_BLUE, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>
                                    {fmtEur(r.total_excl_tax_cents || 0)}
                                </span>
                            </div>
                        ))}
                    </div>
                )}
            </Dialog>
        );
    }

    renderProgressDialog() {
        const { progress } = this.state;
        if (!progress) return null;
        const pct = progress.total > 0 ? (progress.done / progress.total) : 0;
        return (
            <Dialog
                title={`Versturen naar Silvasoft (${progress.done} / ${progress.total})`}
                modal={true}
                open={true}
                contentStyle={{ width: 520, maxWidth: '90%' }}
            >
                <LinearProgress mode="determinate" value={pct * 100} color={BRAND_ORANGE} style={{ marginBottom: 16, height: 6, borderRadius: 3 }} />
                {progress.current && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 12px', background: '#fff7ed', borderRadius: 6, marginBottom: 12 }}>
                        <CircularProgress size={18} thickness={2} />
                        <span style={{ fontSize: 13 }}>Bezig met <strong>{progress.current}</strong>...</span>
                    </div>
                )}
                <div style={{ maxHeight: 240, overflowY: 'auto' }}>
                    {progress.results.map((r, i) => (
                        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', borderBottom: '1px solid #f3f4f6', fontSize: 13 }}>
                            <span style={r.ok ? styles.successPill : styles.failPill}>
                                {r.ok ? `#${r.invoice_number}` : 'MISLUKT'}
                            </span>
                            <span style={{ flex: 1 }}>{r.name}</span>
                            {r.error && <span style={{ color: '#b91c1c', fontSize: 11 }}>{r.error}</span>}
                        </div>
                    ))}
                </div>
            </Dialog>
        );
    }

    renderTaxPicker() {
        const { taxPicker, taxOverride } = this.state;
        if (!taxPicker) return null;
        const current = taxOverride[taxPicker.user_id];
        const options = [
            { val: 0,  label: '0%',  hint: 'BTW verlegd / Reverse charge' },
            { val: 9,  label: '9%',  hint: 'Verlaagd tarief' },
            { val: 21, label: '21%', hint: 'Standaard tarief NL' },
        ];
        return (
            <Popover
                open={true}
                anchorEl={taxPicker.anchor}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                onRequestClose={this.closeTaxPicker}
                style={{ marginTop: 4 }}
            >
                <Menu desktop={true} width={200} listStyle={{ paddingTop: 4, paddingBottom: 4 }}>
                    {options.map((o) => (
                        <MenuItem
                            key={o.val}
                            primaryText={o.label}
                            secondaryText={o.hint}
                            onClick={this.pickTax(taxPicker.user_id, o.val)}
                            innerDivStyle={{ paddingLeft: 12, fontSize: 13 }}
                            style={current === o.val ? { background: '#eef2ff', fontWeight: 600 } : null}
                        />
                    ))}
                </Menu>
            </Popover>
        );
    }

    renderConfirmDialog() {
        const { confirm } = this.state;
        if (!confirm) return null;
        return (
            <Dialog
                title={confirm.title}
                modal={true}
                open={true}
                actions={[
                    <FlatButton label="Annuleer" onClick={this.closeConfirm} />,
                    <RaisedButton
                        label={confirm.confirmLabel}
                        primary
                        style={{ marginLeft: 8 }}
                        onClick={() => { const cb = confirm.onConfirm; this.closeConfirm(); cb && cb(); }}
                    />,
                ]}
            >
                {confirm.body}
            </Dialog>
        );
    }

    renderPickerDialog() {
        const { picker, relations, relationsLoading, relationsError, relationFilter } = this.state;
        if (!picker) return null;

        const filtered = (relations || []).filter((r) => {
            if (!relationFilter) return true;
            const q = relationFilter.toLowerCase();
            return (r.name || '').toLowerCase().includes(q) || String(r.relation_id).includes(q) || (r.email || '').toLowerCase().includes(q);
        });

        return (
            <Dialog
                title="Kies Silvasoft-klant om aan te koppelen"
                modal={false}
                open={true}
                onRequestClose={() => this.setState({ picker: null })}
                autoScrollBodyContent={true}
                actions={[
                    <FlatButton label="Ververs" onClick={() => this.loadRelations(true)} />,
                    <FlatButton label="Annuleer" onClick={() => this.setState({ picker: null })} />,
                ]}
            >
                <TextField
                    fullWidth
                    hintText="Zoek op naam, email of CustomerNumber..."
                    value={relationFilter}
                    onChange={(_e, v) => this.setState({ relationFilter: v })}
                />
                {relationsLoading && <div style={{ padding: 20 }}><CircularProgress size={24} /></div>}
                {relationsError && <div style={{ color: '#c62828', padding: 10 }}>{relationsError}</div>}
                {!relationsLoading && relations && (
                    <List>
                        {filtered.slice(0, 200).map((r) => (
                            <ListItem
                                key={r.relation_id}
                                primaryText={`${r.name} (#${r.relation_id})`}
                                secondaryText={`${r.country_code || '?'} · ${r.vat_number || 'geen VAT'} · ${r.email || ''} · BTW ${this.deriveTaxPc(r)}%`}
                                onClick={this.pickRelation(r)}
                            />
                        ))}
                        {filtered.length === 0 && <Subheader>Geen klanten gevonden</Subheader>}
                    </List>
                )}
            </Dialog>
        );
    }

    render() {
        const { from, to, loading, preview, submitting, snackbar } = this.state;
        let includedCount = 0;
        let includedCents = 0;
        if (preview) {
            preview.groups.forEach((g) => g.lines.forEach((l) => {
                if (!l.unmapped && this.state.checked[l.user_id]) {
                    includedCount += 1;
                    includedCents += l.amount_excl_tax_cents;
                }
            }));
        }
        const mappedGroups = preview ? preview.groups.filter((g) => !g.unmapped) : [];
        const unmappedGroups = preview ? preview.groups.filter((g) => g.unmapped) : [];

        return (
            <div style={styles.page}>
                <div style={styles.headerBar}>
                    <div>
                        <h1 style={styles.pageTitle}>Facturatie</h1>
                        <div style={styles.pageSubtitle}>Selecteer periode → controleer → verstuur naar Silvasoft</div>
                    </div>
                    <div style={styles.toolbar}>
                        <DatePicker style={styles.datePickerStyle} textFieldStyle={{ width: 120 }} hintText="Van" value={from} onChange={(_e, d) => this.setState({ from: d })} container="inline" autoOk locale="nl" mode="portrait" formatDate={(d) => d ? d.toLocaleDateString('nl-NL') : ''} />
                        <span style={{ color: '#9ca3af' }}>→</span>
                        <DatePicker style={styles.datePickerStyle} textFieldStyle={{ width: 120 }} hintText="T/m" value={to} onChange={(_e, d) => this.setState({ to: d })} container="inline" autoOk locale="nl" mode="portrait" formatDate={(d) => d ? d.toLocaleDateString('nl-NL') : ''} />
                        <RaisedButton primary label={loading ? 'Laden...' : 'Genereer'} onClick={this.loadPreview} disabled={loading} style={{ marginLeft: 8 }} />
                        {this.state.lastRunId && (
                            <FlatButton
                                label={this.state.loadingPrevRun ? 'Laden...' : `Vorig resultaat`}
                                onClick={this.loadPreviousRun}
                                disabled={this.state.loadingPrevRun}
                                style={{ marginLeft: 4 }}
                            />
                        )}
                        <FlatButton
                            label="Historie"
                            onClick={this.openHistory}
                            style={{ marginLeft: 4 }}
                        />
                    </div>
                </div>

                {preview && this.renderReconciliation()}

                {loading && <div style={styles.emptyState}><CircularProgress size={28} /><div style={{ marginTop: 8 }}>Concept laden...</div></div>}

                {preview && mappedGroups.length === 0 && unmappedGroups.length === 0 && (
                    <div style={styles.emptyState}>Geen klanten met klikkosten in deze periode.</div>
                )}

                {mappedGroups.map(this.renderGroup)}
                {unmappedGroups.length > 0 && (
                    <div style={{ marginTop: 24, marginBottom: 8, fontSize: 11, fontWeight: 600, color: '#92400e', letterSpacing: 0.5, textTransform: 'uppercase' }}>
                        Nog te koppelen ({unmappedGroups[0].lines.length})
                    </div>
                )}
                {unmappedGroups.map(this.renderGroup)}

                {preview && (
                    <div style={styles.submitBar}>
                        <div style={styles.submitInfo}>
                            <strong>{includedCount}</strong> regel{includedCount === 1 ? '' : 's'} aangevinkt
                            <span style={styles.submitTotal}>{fmtEur(includedCents)}</span>
                        </div>
                        <RaisedButton
                            primary
                            disabled={submitting || includedCount === 0 || !preview.product_number_present}
                            label={submitting ? 'Verzenden...' : 'Verstuur naar Silvasoft'}
                            onClick={this.submit}
                            buttonStyle={{ background: BRAND_ORANGE }}
                        />
                    </div>
                )}

                {this.renderRunResult()}
                {this.renderPickerDialog()}
                {this.renderConfirmDialog()}
                {this.renderTaxPicker()}
                {this.renderProgressDialog()}
                {this.renderHistoryDialog()}

                <Snackbar
                    open={snackbar.open}
                    message={snackbar.msg}
                    autoHideDuration={3500}
                    onRequestClose={() => this.setState({ snackbar: { open: false, msg: '' } })}
                />
            </div>
        );
    }
}

export default Facturatie;



// WEBPACK FOOTER //
// ./src/silvasoft/Facturatie.js